<template>
  <div>
      <div class="vieHead">
        <div class="wapLogo"><img src="@/assets/images/wap/wapLogo.png" alt=""></div>
        <div class="wapmore" @click="popupShow=!popupShow"><img src="@/assets/images/wap/more.png" alt=""></div>
        <van-popup v-model="popupShow"  position="top"  :style="{ 'margin-top': '50px' }" :overlay-style="{'margin-top':'50px'}"  >
            <div class="navwrap">
                <van-cell is-link title="主页" @click="popupShow = false" to="/wapHome" />
                <!-- <van-cell is-link title="产品服务" @click="popupShow = false" to="/wapProducts" /> -->
                <van-cell id="wapProducts"  @click="childshow = !childshow" >
                    <template #title>
                        <span :class="{selcol:childshow}">产品服务</span>
                    </template>
                    <template #right-icon>
                        <van-icon name="arrow" v-if="!childshow"/>
                        <span v-else class="selcol">• • •</span>
                    </template>
                </van-cell>

                <div style="padding-left:20px;" v-show="childshow">
                    <van-cell is-link title="5G消息" @click="popupShow = false" to="/wapProducts" />
                    <van-cell is-link title="短信" @click="popupShow = false" to="/wapSMSPro" />
                    <van-cell is-link title="短信视频" @click="popupShow = false" to="/wapVDPro" />
                </div>

                <van-cell is-link title="行业应用" @click="popupShow = false" to="/wapApplication" />
                <van-cell is-link title="成为开发者" @click="popupShow = false" to="/wapDeveloper"/>
                <!-- <van-action-sheet v-model="show" :actions="actions" @select="onSelect" /> -->
            </div>
        </van-popup>
    </div>
    <div class="swiperBox" v-if="$route.path == '/wapHome' || $route.path == '/wapApplication'">
        <van-swipe class="my-swipe" :autoplay="3000"  indicator-color="white" >
            <van-swipe-item><img src="@/assets/images/wap/1.png" alt=""></van-swipe-item>
            <van-swipe-item><img src="@/assets/images/wap/2.png" alt=""></van-swipe-item>
            <van-swipe-item><img src="@/assets/images/wap/3.png" alt=""></van-swipe-item>
            <van-swipe-item><img src="@/assets/images/wap/4.png" alt=""></van-swipe-item>
            <van-swipe-item><img src="@/assets/images/wap/5.png" alt=""></van-swipe-item>
        </van-swipe>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            popupShow:false,
            childshow:true
        }
    }
}
</script>

<style scoped>
.vieHead{
    width: 100%;
    height: 50px;
    padding: 0 10px 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.swiperBox img{
    width: 100%;
    height: 100%;
    /* object-fit: contain; */
    object-fit: cover;
}
.wapLogo{
    width: 136px;
    height: 36px;
}
.wapLogo img,.wapmore img{
    width: 100%;
}
.wapmore{
    width: 25px;
    /* height: 25px; */ 
}
.van-cell::after{
    display: none;
}
.van-cell__right-icon{
    color: #fff;
}
.van-cell{
    background: none;
    color: #fff;
}
.navwrap{
    background: #2A2B2C;
    padding-top:10px;
    border-bottom: 1px solid #5C5D5E;
}
.selcol{
    color: #8E9090;
}
</style>


// WEBPACK FOOTER //
// src/components/wepHearder.vue